export default {
    description: "Beschreibung",
    orderingNote: "Bestellhinweis"
}